import { createContext, useContext, useState } from "react"

// Create the context
const UserContext = createContext()

// Custom hook to access UserContext
export const useUser = () => {
  return useContext(UserContext)
}

// Provider component
export const UserProvider = ({ children }) => {
  const [context_user, setUser] = useState(null)

  // Function to update user info
  const updateUser = (newUserData) => {
    setUser(newUserData)
  }

  return (
    <UserContext.Provider value={{ context_user, updateUser }}>{children}</UserContext.Provider>
  )
}
